import { render, staticRenderFns } from "./add_editclr.vue?vue&type=template&id=63bbe55b&scoped=true&"
import script from "./add_editclr.vue?vue&type=script&lang=js&"
export * from "./add_editclr.vue?vue&type=script&lang=js&"
import style0 from "./add_editclr.vue?vue&type=style&index=0&id=63bbe55b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bbe55b",
  null
  
)

export default component.exports